module.exports = __webpack_public_path__ + "img/builder-15.becab506.webp";